import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import "core-js/modules/es6.function.name";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import { Box } from '@origin-digital/layout';
import * as React from 'react';
import { fieldBasePropTypes } from './Field.types';
import { internalStateReducer, initialState, defaultProps, displayName } from './field.helper';
import { compose } from '../../helpers';
import { triggerEvent } from '../../helpers/dom.helper';
import { HiddenInput } from './components/HiddenInput';

var Field =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Field, _React$Component);

  function Field(props) {
    var _this;

    _classCallCheck(this, Field);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Field).call(this, props));
    _this.initialState = initialState(_this.props);
    _this.state = _this.initialState;

    _this.onChange = function (event) {
      // console.log(event.target.value);
      var internalValue = event.target.value;
      var name = event.target.name;
      var pristine = _this.state.initial === internalValue;
      var dirty = !pristine;

      _this.internalSetState('change', {
        dirty: dirty,
        internalValue: internalValue,
        pristine: pristine
      }, function () {
        if (_this.props.onChange) {
          triggerEvent(_this.hiddenInputRef, 'change', _this.state.internalValue);
        }
      });
    };

    _this.onBlur = function (event) {
      var active = false;
      var touched = true;

      _this.internalSetState('blur', {
        active: active,
        touched: touched
      }, function () {
        if (_this.props.onBlur) {
          triggerEvent(_this.hiddenInputRef, 'blur', _this.state.internalValue);
        }
      });
    };

    _this.onFocus = function (event) {
      var name = event.target.name;
      var active = true;
      var visited = true;

      _this.internalSetState('focus', {
        active: active,
        visited: visited
      }, function () {
        if (_this.props.onFocus) {
          triggerEvent(_this.hiddenInputRef, 'focus', _this.state.internalValue);
        }
      });
    };

    _this.onMouseDown = function (event) {
      var bounds = event.currentTarget.getBoundingClientRect();
      var xClickLast = Math.floor(event.clientX - bounds.left);

      _this.setState({
        xClickLast: xClickLast
      });
    };

    _this.setHiddenInputRef = _this.setHiddenInputRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(Field, [{
    key: "setHiddenInputRef",
    value: function setHiddenInputRef(ref) {
      this.hiddenInputRef = ref;
    }
  }, {
    key: "internalSetState",
    value: function internalSetState(type, changes, callback) {
      var _this2 = this;

      this.setState(function (prevState) {
        var changesObject = typeof changes === 'function' ? changes(prevState) : changes;
        var stateReducer = compose(_this2.props.stateReducer, internalStateReducer);
        var reducedChanges = stateReducer({
          type: type,
          currentState: prevState,
          changes: changesObject
        }).changes || {};
        return _Object$keys(reducedChanges).length ? reducedChanges : null;
      }, callback);
    }
  }, {
    key: "getRenderPropPayload",
    value: function getRenderPropPayload() {
      var _this$state = this.state,
          touched = _this$state.touched,
          active = _this$state.active,
          initial = _this$state.initial,
          internalValue = _this$state.internalValue,
          xClickLast = _this$state.xClickLast;
      var dirty = initial !== internalValue;
      var pristine = !dirty;
      var error = this.props.error;
      var valid = (initial || dirty || touched) && !error && !active;
      var showError = touched && !!error;
      return {
        input: {
          onBlur: this.onBlur,
          onChange: this.onChange,
          onFocus: this.onFocus,
          value: internalValue
        },
        meta: {
          showError: showError,
          valid: valid,
          active: active,
          initial: initial,
          dirty: dirty,
          pristine: pristine,
          touched: touched,
          xClickLast: xClickLast
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          width = _this$props.width,
          height = _this$props.height,
          children = _this$props.children,
          onChange = _this$props.onChange,
          onBlur = _this$props.onBlur,
          onFocus = _this$props.onFocus,
          name = _this$props.name,
          orderHiddenInputLast = _this$props.orderHiddenInputLast;
      var hiddenInput = React.createElement(HiddenInput, {
        name: name,
        innerRef: this.setHiddenInputRef,
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur
      });
      return React.createElement(Box, {
        minWidth: 100,
        width: width,
        height: height,
        display: "flex",
        "data-id": this.props['data-id']
      }, React.createElement(Box, {
        marginBottom: 4,
        onMouseDown: this.onMouseDown,
        display: "flex",
        direction: "row",
        flex: "grow",
        position: "relative"
      }, !orderHiddenInputLast && hiddenInput, children(this.getRenderPropPayload()), orderHiddenInputLast && hiddenInput));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      return {
        controlledValue: nextProps.value,
        internalValue: nextProps.value !== prevState.controlledValue ? nextProps.value : prevState.internalValue,
        touched: nextProps.touched !== null ? nextProps.touched : prevState.touched
      };
    }
  }]);

  return Field;
}(React.Component);

Field.propTypes = fieldBasePropTypes;
Field.displayName = displayName;
Field.defaultProps = defaultProps;
export { Field };